<template>
    <v-app id="app" :class="{ mobile: $vuetify.breakpoint.mdAndDown }">
        <div v-if="!isOnline" class="offline-screen">
            <img src="/pwa/img/icons/android-chrome-192x192.png" alt="Логотип">
            <h2>Нет подключения к интернету</h2>
            <p>Проверьте соединение и попробуйте снова.</p>
            </div>

            <!-- Если онлайн — показываем интерфейс -->
        <div v-else>
            <SystemBar/>
            <AppBar v-if="isPublicScreen || isHomeScreen"/>
            <v-main
                :class="{
                    'primary': isSplashScreen || isStartScreen || isAuthScreen,
                }"
            >
                <div v-if="pageTitle" class="page-title">
                    {{ pageTitle }}
                </div>
                <div
                    class="main"
                >
                    <router-view/>
                </div>
            </v-main>
            <BottomNavigation v-if="isHomeScreen" :items="bottomNavigationMenu"/>
            <InstallAppleDialog :show.sync="isShownInstallAppleDialog"/>
            <Snackbar/>
        </div>
    </v-app>
</template>

<script>
    import { mapGetters, mapState } from 'vuex'

    import AppBar from '@/components/Vuetify/AppBar'
    import BottomNavigation from '@/components/Vuetify/BottomNavigation'
    // import NavigationDrawer from '@/components/Vuetify/NavigationDrawer'
    import Snackbar from '@/components/Vuetify/Snackbar'
    import SystemBar from '@/components/Vuetify/SystemBar'

    import InstallAppleDialog from '@/components/app/Install/InstallAppleDialog'

    import repairIcon from '@/assets/icons/repairIcon'
    import actionsIcon from '@/assets/icons/actionsIcon'
    import myCarsIcon from '@/assets/icons/myCarsIcon'
    import historyIcon from '@/assets/icons/historyIcon'
    import addressIcon from '@/assets/icons/addressIcon'

    export default {
        name: 'App',

        components: {
            AppBar,
            BottomNavigation,
            // NavigationDrawer,
            Snackbar,
            SystemBar,
            //
            InstallAppleDialog,
        },

        data: () => ({
            bottomNavigationMenu: [
                {
                    text: 'Ремонт',
                    icon: repairIcon,
                    route: { name: 'Station' },
                },
                {
                    text: 'Акции',
                    icon: actionsIcon,
                    route: { name: 'Promo' },
                },
                {
                    text: 'Мои авто',
                    icon: myCarsIcon,
                    route: { name: 'Garage' },
                },
                {
                    text: 'История',
                    icon: historyIcon,
                    route: { name: 'History' },
                },
                {
                    text: 'Адреса',
                    icon: addressIcon,
                    route: { name: 'StationAddress' },
                },
            ],

            isShownInstallAppleDialog: false,
            showSignOutDialog: false,
            showSignOutDialogMobile: false,
            isOnline: navigator.onLine,
        }),

        computed: {
            ...mapState('auth', {
                isSignOut: state => state.isSignOut,
            }),

            ...mapState('softwareUpdate', {
                softwareUpdateState: state => state,
            }),

            ...mapState('ui', {
                uiState: state => state,
            }),

            ...mapState('client', {
                clientState: state => state,
            }),

            ...mapGetters({
                isAuthorized: 'auth/isAuthorized',
            }),

            isSplashScreen() {
                return this.$route.matched.some(route => route.name === 'Splash')
            },

            isPublicScreen() {
                return this.$route.matched.some(route => route.name === 'Public')
            },

            isStartScreen() {
                return this.$route.matched.some(route => route.name === 'Start')
            },

            isAuthScreen() {
                return this.$route.matched.some(route => route.name === 'Auth')
            },

            isHomeScreen() {
                return this.$route.matched.some(route => route.name === 'Home')
            },

            isShownNavigationDrawer: {
                get() {
                    return false
                    // return this.uiState.navigationDrawer.isShown
                },
                set(show) {
                    this.$store.commit('ui/setNavigationDrawer', { isShown: show })
                },
            },

            navigationDrawerMenu() {
                let menu = []

                if (this.isAuthorized) {
                    if (this.$vuetify.breakpoint.mdAndDown) {
                        menu.push(this.bottomNavigationMenu[0])
                    } else {
                        menu = [...menu, ...this.bottomNavigationMenu]
                    }

                    menu.push({
                        text: 'История обслуживания',
                        route: { name: 'History' },
                    })

                    menu.push({
                        text: 'Адреса СТО',
                        route: { name: 'StationAddress' },
                    })

                    const bonuses = this.$store.state.client.client?.bonuses

                    menu.push({
                        text: 'Бонусы',
                        accent: bonuses,
                        route: { name: 'Bonus' },
                    })

                    menu.push({
                        text: 'Чат',
                        click: () => this.openChat(),
                    })
                } else {
                    menu.push({
                        text: 'Старт',
                        route: { name: 'Start' },
                    })

                    menu.push({
                        text: 'Адреса СТО',
                        route: { name: 'PublicStationAddress' },
                    })
                }

                if (this.isAuthorized) {
                    menu.push({
                        text: 'Выйти',
                        click: () => this.signOut(),
                    })
                }

                return menu
            },

            pageTitle() {
                return this.$route.meta?.pageTitle
            },

            isMobile() {
                return this.$vuetify.breakpoint.smAndDown
            },
        },

        watch: {
            isSignOut: {
                handler(isSignOut) {
                    if (isSignOut && !this.$route.matched.some(route => route.name === 'Public')) {
                        this.$store.dispatch('clear')

                        this.$router.push({ name: 'Public' })
                    }
                },
                immediate: true,
            },
        },

        created() {
            window.addEventListener('online', this.updateOnlineStatus)
            window.addEventListener('offline', this.updateOnlineStatus)
            // Software Update
            document.addEventListener('serviceWorkerUpdated', this.onServiceWorkerUpdated, { once: true })

            navigator.serviceWorker.addEventListener('controllerchange', () => {
                if (this.softwareUpdateState.isUpdating) {
                    return
                }

                this.$store.commit('softwareUpdate/setUpdating', true)

                window.location.reload()
            })

            // Chat
            if (!document.querySelector('.b24-widget-button-wrapper')) {
                (function (w, d, u) {
                    var s = d.createElement('script')
                    s.async = true
                    s.src = u + '?' + (Date.now() / 60000 | 0)
                    var h = d.getElementsByTagName('script')[0]
                    h.parentNode.insertBefore(s, h)
                })(window, document, 'https://cdn.bitrix24.ru/b2919677/crm/site_button/loader_14_37wani.js')
            }
        },

        beforeDestroy() {
            window.removeEventListener('online', this.updateOnlineStatus)
            window.removeEventListener('offline', this.updateOnlineStatus)
        },

        mounted() {
            this.isShownNavigationDrawer = this.$vuetify.breakpoint.lgAndUp

            this.$store.dispatch('promotion/fetch')

            // Показываем окно установки приложения для iOS
            if (!navigator.standalone) {
                if (['iPhone', 'iPad', 'iPod'].includes(navigator.platform)) {
                    setTimeout(() => {
                        this.isShownInstallAppleDialog = true
                    }, 1000)
                }
            }
        },

        methods: {
            updateOnlineStatus() {
                this.isOnline = navigator.onLine
            },

            async onServiceWorkerUpdated(event) {
                // Обновление найдено
                await this.$store.dispatch('softwareUpdate/setServiceWorkerRegistration', event.detail)

                await this.$root.pushNotification({
                    text: 'Новая версия ПО',
                    action: {
                        text: 'Обновить',
                        click: () => this.$store.dispatch('softwareUpdate/update'),
                    },
                })
            },

            async signOutHandler() {
                await this.$store.dispatch('auth/signOut')
            },

            signOut() {
                if (this.isMobile) {
                    this.showSignOutDialogMobile = true
                } else {
                    this.showSignOutDialog = true
                }
            },

            openChat() {
                const chatBtn = document.querySelector('.b24-widget-button-block')

                if (chatBtn) {
                    chatBtn.click()
                }
            },
        },
    }
</script>

<style lang="scss">
    div.b24-widget-button-visible {
        display: none;
    }
    .v-main__wrap {
        max-width: 1280px;
        width: 100%;
        margin-left: auto;
        margin-right: auto;
    }
    .main {
        background-color: #FFF;
        border-radius: 16px;
        padding: 50px;
        clear: both;
    }
    .mobile .main {
        max-width: 1280px;
        width: 100%;
        margin: auto;
        background-color: #FFF;
        border-radius: 15px;
        padding: 0;
    }
    .v-application {
        background-color: #F3F3F3 !important;
        font-family: Montserrat;
    }
    .page-title {
        color: #36393B;
        font-size: 36px;
        font-style: normal;
        font-weight: 700;
        line-height: 140%;
        margin-bottom: 40px;
    }
    .mobile .page-title {
        font-size: 22px;
        padding: 0 16px;
        margin-bottom: 20px;
    }

    .v-application .overline {
        letter-spacing: normal !important;
        line-height: 1.5 !important;
    }

    .offline-screen {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 100vh;
        background: #f5f5f5;
        color: #333;
        text-align: center;
        padding: 20px;
    }
    .offline-screen img {
        width: 96px;
        margin-bottom: 24px;
    }
</style>
